export function watchRefreshKeyPress() {
    // console.log(this.$route.name)
    document.onkeydown = function(e){
        /* F5, Ctrl+r, Ctrl+F5 */
        if(e.keyCode == 116 || e.ctrlKey == true && (e.keyCode == 82)){
            e.cancelBubble = true; 
            e.returnValue = false;
            var confirmPop = confirm("신청진행중인 정보가 유실될 수 있습니다.\n새로고침하시겠습니까?")
            if(confirmPop === true) {
                window.location.reload();
            }
            return false;
        }
    }
}